import React from 'react';
import { MenuHorizontalIcon } from 'cokitchen-icons';
import './styles.scss';
import useDashboardContext from 'contexts/dashboard.context';
import { SideModal } from '@cokitchen/cokitchen-components';
import { ReactComponent as ArrowBackIcon } from 'assets/icons/arrow-back.svg';
import { ReactComponent as FoodCourtLogo } from 'assets/logo.svg';
import { useNavigate } from 'react-router-dom';
import NotificationDropdown from 'components/notification/notification-dropdown';
import Sidebar from 'components/sidebar';
import useRoleContext from 'contexts/role.context';
import { ENUM_ALL_ROLES } from 'utils/roles';
import CokitchenDropdown from './cokitchen-dropdown';
import UserDropdown from 'components/user-dropdown';

type Props = {
  title?: string;
  hideSideBar?: boolean;
};

const Header = ({ title, hideSideBar }: Props) => {
  const { showMobileSidebar, setShowMobileSidebar, isBackLink } = useDashboardContext();
  // const { isBackLink: backLink } = useProductionReportContext();
  const { role } = useRoleContext();

  const navigate = useNavigate();
  const showLogo = hideSideBar && role?.name === ENUM_ALL_ROLES.KITCHEN_ADMIN && !isBackLink;

  return (
    <div className=' font-medium px-3 lg:pr-14 py-4 border-b border-[#EFF0F0] flex  flex-wrap gap-4 items-center text-sm h-[80px]'>
      <div className='grow flex items-center h-[100%] '>
        <div className='inline-flex gap-2 items-center '>
          {isBackLink && (
            <div className='gap-3 items-center cursor-pointer  flex' onClick={() => navigate(-1)}>
              <div className='w-[30px] h-[30px]  bg-[#F4F1F1] flex justify-center items-center rounded-full'>
                <ArrowBackIcon />
              </div>
              <p className='text-sm font-medium text-[#2E3031]'>{title}</p>
            </div>
          )}
          {!hideSideBar && (
            <span
              role='menubar'
              onClick={() => setShowMobileSidebar(true)}
              className='p-2 bg-black rounded-full text-white lg:hidden'>
              <MenuHorizontalIcon />
            </span>
          )}
          {showLogo && (
            <div>
              <FoodCourtLogo className='ml-7' />
            </div>
          )}
        </div>
      </div>

      {!isBackLink && (
        <div className='flex items-center gap-4 flex-wrap'>
          <CokitchenDropdown />
          <div className='flex items-center gap-4'>
            <NotificationDropdown />
            <UserDropdown />
          </div>
        </div>
      )}

      <SideModal
        title=''
        isOpen={showMobileSidebar}
        onRequestClose={() => setShowMobileSidebar(false)}
        hideFooter>
        <Sidebar />
      </SideModal>
    </div>
  );
};

export default Header;
